import { Component } from '@angular/core';

import { ApiWalletService } from '../../data/services/api/api-wallet.service';
import { WALLET_COLUMNS } from '../../data/constants/wallet.constants';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-wallets-detail',
  templateUrl: './wallets-detail.component.html',
  styleUrls: ['./wallets-detail.component.scss']
})
export class WalletsDetailComponent {
  columns = WALLET_COLUMNS;
  wallet!: any
  loading = true;

  constructor(
    public apiWalletService: ApiWalletService,
    private activatedRoute: ActivatedRoute
  ) {
    this.wallet = this.apiWalletService.wallet
    this.apiWalletService.walletId = this.activatedRoute.snapshot.paramMap.get('id') ?? ''

    this.apiWalletService.getOneWalletAmounts().subscribe(wallet => {
      this.wallet = wallet;
      this.loading = false;
    }); 
  }
}
